import { Popover } from 'antd';
import { PureComponent, ReactNode } from 'react';
import PatientHealthSummaryPopover from './Popover';
import { PatientHealthSummaryResponse } from '../../../api/getPatientHealthSummary';
import { AntTooltip } from '../AntTooltip';
import { getAclViewClassName } from '../../../restrictions/utils';
import { SREV2 } from '../../../api/pushGenie';

interface Props {
    patientId: string;
    patientName: string;
    toggleAllInsightsModalVisible: (patientHealthSummary?: PatientHealthSummaryResponse) => void;
}

interface State {
    visible: boolean;
}

class PatientHealthSummaryPopoverIcon extends PureComponent<Props> {
    state: State = {
        visible: false,
    };

    onVisibleChange = (visible: boolean): void => {
        this.setState({
            visible: visible,
        });
    };

    toggleAllInsightsModalVisible = (patientHealthSummary?: PatientHealthSummaryResponse): void => {
        const { toggleAllInsightsModalVisible } = this.props;
        const { onVisibleChange } = this;
        toggleAllInsightsModalVisible(patientHealthSummary);
        onVisibleChange(false);
    };

    render(): ReactNode {
        const { patientId, patientName } = this.props;
        const { visible } = this.state;
        const { onVisibleChange, toggleAllInsightsModalVisible } = this;

        return (
            <Popover
                content={
                    <PatientHealthSummaryPopover
                        patientId={patientId}
                        patientName={patientName}
                        closeMe={() => onVisibleChange(false)}
                        toggleAllInsightsModalVisible={toggleAllInsightsModalVisible}
                    />
                }
                title={null}
                trigger={'click'}
                overlayClassName="popover-p-0 patient-health-summary-popover"
                placement="rightTop"
                visible={visible}
                onVisibleChange={onVisibleChange}
                destroyTooltipOnHide
                getPopupContainer={() => document.getElementById(patientId) || document.body}
            >
                <AntTooltip
                    content="Doc.Assist at your service!"
                    placement="top"
                    getPopupContainer={() =>
                        document.getElementById(`patient-health-summary-${patientId}`) ||
                        document.body
                    }
                >
                    <p
                        className={`hover-child-element ${getAclViewClassName(SREV2.DOC_ASSIST)}`}
                        onClick={(e) => e.stopPropagation()}
                        id={`patient-health-summary-${patientId}`}
                    >
                        <img
                            src="/images/health-summary-icon.png"
                            alt="health summary icon"
                            className="w-24 h-24"
                        />
                    </p>
                </AntTooltip>
            </Popover>
        );
    }
}

export default PatientHealthSummaryPopoverIcon;
